import { localStorageInterface } from '../interfaces/localStorageInterface';

/* eslint-disable no-console */

class LoggerConfigurator {
  constructor() {
    this.featureFlagLoggingLevel = null;
    this.LogLevelsEnum = Object.freeze({
      DEBUG: 0,
      LOG: 1,
      INFO: 2,
      WARN: 3,
      ERROR: 4,
      FATAL: 5,
      OFF: 6,
    });
  }

  retrieveLoggingLevel = () => {
    let loggingLevel = process.env.NODE_ENV !== 'test' ? this.LogLevelsEnum.INFO : this.LogLevelsEnum.OFF; // default for prod

    if (typeof this.featureFlagLoggingLevel === 'number') {
      if (
        this.featureFlagLoggingLevel >= this.LogLevelsEnum.DEBUG &&
        this.featureFlagLoggingLevel <= this.LogLevelsEnum.OFF
      ) {
        loggingLevel = this.featureFlagLoggingLevel;
      }
    }

    const loggingLevelLocal = localStorageInterface.getItem('loggingLevel');
    const localLoggingLevelNumber = loggingLevelLocal ? Number(loggingLevelLocal) : undefined;
    if (localLoggingLevelNumber >= this.LogLevelsEnum.DEBUG && localLoggingLevelNumber <= this.LogLevelsEnum.OFF) {
      loggingLevel = localLoggingLevelNumber;
    }

    return loggingLevel;
  };

  storeLoggingLevel = (loggingLevel) => {
    localStorageInterface.setItem('loggingLevel', loggingLevel);
  };

  setFeatureFlagLoggingLevel = (level) => {
    this.featureFlagLoggingLevel = level;
  };
}

const Logger = {
  loggingLevelOverride: undefined,
  debug(...args) {
    if (this.loggingLevel() <= configurator.LogLevelsEnum.DEBUG) {
      const message = (args && args.shift()) || '';
      console.debug(`%c${this.name} DEBUG:  ${message}`, 'color: green;', ...args);
    }
  },
  log(...args) {
    if (this.loggingLevel() <= configurator.LogLevelsEnum.LOG) {
      const message = (args && args.shift()) || '';
      console.log(`%c${this.name} LOG: ${message}`, 'color: navy;', ...args);
    }
  },
  info(...args) {
    if (this.loggingLevel() <= configurator.LogLevelsEnum.INFO) {
      const message = (args && args.shift()) || '';
      console.info(`%c${this.name} INFO:  ${message}`, 'color: blue;', ...args);
    }
  },
  warn(...args) {
    if (this.loggingLevel() <= configurator.LogLevelsEnum.WARN) {
      const message = (args && args.shift()) || '';
      console.warn(`%c${this.name} WARN:  ${message}`, 'color: crimson;', ...args);
    }
  },
  error(...args) {
    if (this.loggingLevel() <= configurator.LogLevelsEnum.ERROR) {
      const message = (args && args.shift()) || '';
      console.error(`%c${this.name} ERROR:  ${message}`, 'color: red;', ...args);
    }
  },
  fatal(...args) {
    if (this.loggingLevel() <= configurator.LogLevelsEnum.FATAL) {
      const message = (args && args.shift()) || '';
      console.error(`%c${this.name} FATAL:  ${message}`, 'color: darkred;', ...args);
    }
  },
  loggingLevel() {
    return this.loggingLevelOverride !== undefined ? this.loggingLevelOverride : configurator.retrieveLoggingLevel();
  },
};

export const configurator = new LoggerConfigurator();
export function getLogger(name) {
  return { ...Logger, name: name || 'logger' };
}
